module.exports = __webpack_public_path__ + "static/media/praxis.0aa6c221.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/praxis.jpg
// module id = 821
// module chunks = 3